<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>平台运维</el-breadcrumb-item>
          <el-breadcrumb-item>共享盘管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>共享盘管理</h4>
        <!-- <p @click="addPic">+新增资源库</p> -->
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <sharemanagetable :tableData="shareManageTableList" @resetClick="resetClick"></sharemanagetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <el-dialog
        :visible.sync="dialogVisible"
        width="26%"
        :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>重置共享盘密码</div>
      </div>
      <div>
        <p style="text-indent:2em;margin-bottom:10px;">您正在重置用户"<span style="color:#185ED3;">{{resetInfor}}</span>"的共享盘密码，重置后密码将立刻变化。</p>
        <p style="text-indent:2em;">但是，在共享盘服务重新启动前，该用户仍然使用旧密码。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="beSure">确定重置</el-button>
        <el-button v-else :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" disabled>确定重置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sharemanagetable } from "@/components/index";
import { mapActions } from "vuex";
import { listLog, listNasAccount,resetNasAccount} from '@/api/system'
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    sharemanagetable: sharemanagetable
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible:false,
      resetInfor:'',
      shareManageTableList: [],
      timeInt: '',
      isRefresh: false,

      isClick:false,

      uid:''
    };
  },
  methods: {
    handleClose(){
      this.dialogVisible = false
    },
    resetClick(e){
      this.dialogVisible = true
      this.uid = e.row.uid
      this.resetInfor = e.row.name + '/' + e.row.mobile
    },
    beSure(){
      this.isClick = true
      setTimeout(() => {
        this.isClick = false
      }, 2000);
      let val = {
        uid:this.uid
      }
      this.resetNasAccountAsync(val)
      this.dialogVisible = false
      
    },
    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listNasAccountAsync(data)
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    
    async resetNasAccountAsync (val) {
      let { status, data, message, errors } = await resetNasAccount(val);
      if (status) {
        this.$message.success('重置成功！')
      }else{
        this.$message.error('重置失败！')
      }
     },

    //获取共享盘列表
    async listNasAccountAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listNasAccount(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          data[i].name = data[i].userInfo.name
          data[i].mobile = data[i].userInfo.mobile
        }

        this.shareManageTableList = data
        this.total = pagination.total
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);

    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./sharemanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
